import React, { Fragment, useState, ReactNode } from 'react';
import {
  ArrowDownIcon,
  MenuHorizontalIcon,
  RmxLogoutIcon,
  RmxProcurementIcon,
  UserAltIcon
} from 'cokitchen-icons';
import NewBusinessModal from 'components/new-business-modal';
import useDashboardContext from 'contexts/dashboard.context';
import Sidebar from '../sidebar';
import { Dropdown, DropdownItem, DropdownList, SideModal } from '@cokitchen/cokitchen-components';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-back.svg';
import { ReactComponent as QuestionIcon } from 'assets/icons/question-icon.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import LogoutModal from '../logout-modal';
import { STORAGE_KEYS } from 'utils/constants';
import NotificationDropdown from './notification/notification-dropdown';
import './styles.scss';
import WalletTransactionsModal from 'components/modals/wallet-transactions-modal';
import HeaderBasket from 'components/header-basket';
import { CompaniesListType } from 'models/company.model';
import { isOnboardingCompleted } from 'utils/functions';

type Props = {
  title?: string;
  backLink?: string;
  needHelp?: ReactNode;
  clickFunction?: () => void;
};

const Header = ({ title, backLink, needHelp, clickFunction }: Props) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedDropdown, setSelectedDropdownOpen] = useState('');
  const {
    showMobileSidebar,
    setShowMobileSidebar,
    isBackLink,
    setActiveCompany,
    companyList,
    hideSidebar,
    activeCompany,
    onboarding
  } = useDashboardContext();
  const [showNewBusinessModal, setShowNewBusinessModal] = useState(false);
  const [showWalletTransactionModal, setShowWalletTransactionModal] = useState(false);
  const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME) ?? '';
  const lastName = localStorage.getItem(STORAGE_KEYS.LAST_NAME) ?? '';
  const email = localStorage.getItem(STORAGE_KEYS.EMAIL);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onboardingCompleted = isOnboardingCompleted(onboarding);

  const toggleModal = () => {
    setShowLogoutModal(!showLogoutModal);
  };
  const handleDropdownItemClick = (itemName: string) => {
    setSelectedDropdownOpen(() => itemName);
    setIsDropdownOpen(false);
  };
  const logout = () => {
    toggleModal();
  };
  const handleLinkClick = () => {
    if (clickFunction) {
      clickFunction();
    } else {
      if (backLink) {
        navigate(backLink);
      } else {
        navigate(-1);
      }
    }
  };
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const company_name = activeCompany?.name ?? '-';
  const newBusinessModal = () => {
    setShowNewBusinessModal(!showNewBusinessModal);
  };
  const handleWalletTransaction = () => {
    setShowWalletTransactionModal(!showWalletTransactionModal);
  };

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const changeCompany = (company: CompaniesListType) => {
    setActiveCompany(company);
    handleDropdownItemClick(company.name);
    localStorage.setItem(STORAGE_KEYS.ADMIN_SKIPPED, company.skip ? 'YES' : 'NO');
    navigate(`/${ROUTE_KEYS.GET_STARTED}`);
  };

  return (
    <div className='sticky top-0 z-50 font-medium w-full bg-white  px-3 lg:pr-5 py-4 border-b border-[#EFF0F0] flex  flex-wrap gap-4 items-center text-sm h-[80px]'>
      {hideSidebar ? (
        <div className='grow flex items-center h-[100%]'>
          <div className='inline-flex gap-2 items-center '>
            {isBackLink && (
              <div className='gap-3 items-center cursor-pointer flex' onClick={handleLinkClick}>
                <div className='w-[30px] h-[30px] bg-[#F4F1F1] flex justify-center items-center rounded-full'>
                  {needHelp ? <QuestionIcon /> : <ArrowBackIcon />}
                </div>
                <p className='text-sm font-medium text-[#2E3031]'>{title}</p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <Fragment>
          <div className='grow flex items-center h-[100%]'>
            <div className='inline-flex gap-2 items-center '>
              {isBackLink && (
                <div
                  className='gap-3 items-center cursor-pointer hidden lg:flex'
                  onClick={handleLinkClick}>
                  <div className='w-[30px] h-[30px] bg-[#F4F1F1] flex justify-center items-center rounded-full'>
                    <ArrowBackIcon />
                  </div>
                  <p className='text-sm font-medium text-[#2E3031]'>{title}</p>
                </div>
              )}
              <span
                role='menubar'
                onClick={() => setShowMobileSidebar(true)}
                className='p-2 bg-black rounded-full text-white lg:hidden'>
                <MenuHorizontalIcon />
              </span>
              <Dropdown
                visible={isDropdownOpen}
                onClickOutside={() => setIsDropdownOpen(false)}
                content={
                  <div
                    onClick={toggleDropdown}
                    className='w-full flex lg:hidden items-center justify-between gap-4 flex-wrap cursor-pointer h-[64px] px-4 border-b border-b-[#EFF0F0]'>
                    <div>
                      <p className='font-medium text-[#2E3031]'>
                        {selectedDropdown ? selectedDropdown : company_name}
                      </p>
                      <div className='bg-[#EDFBEA] rounded-[20px] w-fit py-[1px] px-[10px]'>
                        <p className='text-[#3FB827] text-xs'>Active</p>
                      </div>
                    </div>
                    <ArrowDownIcon
                      className={`text-gray-8 ${isDropdownOpen ? 'rotate-180' : ''}`}
                    />
                  </div>
                }>
                <DropdownList>
                  {companyList.length === 1 ? (
                    <DropdownItem>No other business</DropdownItem>
                  ) : (
                    companyList
                      ?.filter((item) => item.id !== activeCompany?.id)
                      .map((company) => (
                        <DropdownItem
                          key={company.id}
                          className='font-medium'
                          onClick={() => changeCompany(company)}>
                          {company.name}
                        </DropdownItem>
                      ))
                  )}
                </DropdownList>
              </Dropdown>
            </div>
          </div>
          <div className='hidden sm:block'>
            {pathname.includes(ROUTE_KEYS.ORDERS) && <HeaderBasket />}
          </div>

          <NotificationDropdown />
          <Dropdown
            visible={showDropdown}
            onClickOutside={() => setShowDropdown(false)}
            className=''
            content={
              <div
                onClick={handleDropdownToggle}
                className='flex items-center gap-1 sm:gap-4 flex-wrap cursor-pointer'>
                <div className='flex items-center gap-2 sm:gap-4'>
                  {activeCompany?.logo === null ? (
                    <div className='flex items-center justify-center w-12 h-12 p-[10px] rounded-full text-white text-lg bg-red-5'>
                      {firstName[0]}
                      {lastName[0]}
                    </div>
                  ) : (
                    <div
                      className=' w-12 h-12 rounded-full'
                      style={{
                        backgroundImage: `url(${activeCompany?.logo})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}
                    />
                  )}
                  <div className='flex-col xl:flex hidden md:block '>
                    <p className='font-medium text-[#2E3031] '>
                      {firstName} {lastName}
                    </p>
                    <p className='text-[#6F7376] text-xs '>{email}</p>
                  </div>
                </div>
                <ArrowDownIcon className={`ml-5 text-gray-8 ${showDropdown ? 'rotate-180' : ''}`} />
              </div>
            }>
            <DropdownList className='max-h-fit list'>
              <DropdownItem className='user_info' onClick={handleDropdownToggle}>
                <div className='flex items-center gap-2 sm:gap-4 pb-2 border-b border-b-[#EFF0F0]'>
                  {activeCompany?.logo ? (
                    <div
                      className=' w-12 h-12 rounded-full'
                      style={{
                        backgroundImage: `url(${activeCompany?.logo})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}
                    />
                  ) : (
                    <div className='flex items-center justify-center w-12 h-12 !p-[10px] rounded-full text-white text-lg bg-red-5'>
                      {firstName[0]}
                      {lastName[0]}
                    </div>
                  )}
                  <div className='flex-col flex'>
                    <p className='font-medium text-[#2E3031]'>
                      {firstName} {lastName}
                    </p>
                    <p className='text-[#6F7376] text-xs'>{email}</p>
                  </div>
                </div>
              </DropdownItem>
              <Link to={onboardingCompleted ? ROUTE_KEYS.PROFILE : '#'}>
                <DropdownItem onClick={handleDropdownToggle}>
                  <div
                    className={`flex gap-3 items-center ${
                      onboardingCompleted ? 'cursor-pointer' : 'cursor-not-allowed'
                    }`}>
                    <UserAltIcon className='text-[#96999C] w-[18px] h-[18px]' />
                    <p className='text-[#5E6164] text-sm font-medium'>Account</p>
                  </div>
                </DropdownItem>
              </Link>
              <DropdownItem onClick={handleWalletTransaction}>
                <div className='flex gap-3 items-center'>
                  <RmxProcurementIcon className='text-[#96999C] w-[18px] h-[18px]' />
                  <p className='text-[#5E6164] text-sm font-medium'>Wallet transactions</p>
                </div>
              </DropdownItem>
              <DropdownItem onClick={logout}>
                <div className='flex gap-3 items-center'>
                  <RmxLogoutIcon className='text-[#96999C] w-[18px] h-[18px]' />
                  <p className='text-[#5E6164] text-sm font-medium'>Logout</p>
                </div>
              </DropdownItem>
              <DropdownItem className='privacy' onClick={handleDropdownToggle}>
                <a
                  href='https://getfoodcourt.com/fcb-privacy-policy'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-gray-12 no-underline text-sm border-t block w-full border-t-gray-14 py-[10px] pl-4'>
                  Privacy policy
                </a>
              </DropdownItem>
            </DropdownList>
          </Dropdown>
        </Fragment>
      )}
      <SideModal
        closeBtnVariant='side'
        bodyClassName='w-[98vw] sm:w-[450px]'
        showTopNavbar
        isOpen={showMobileSidebar}
        onRequestClose={() => setShowMobileSidebar(false)}>
        <Sidebar />
      </SideModal>
      {showWalletTransactionModal && (
        <WalletTransactionsModal
          onClose={handleWalletTransaction}
          isOpen={showWalletTransactionModal}
        />
      )}
      <LogoutModal onClose={toggleModal} show={showLogoutModal} />
      <NewBusinessModal show={showNewBusinessModal} onClose={newBusinessModal} />
    </div>
  );
};

export default Header;
